import { render, staticRenderFns } from "./PostTippingModal.vue?vue&type=template&id=2b5bec82&scoped=true&"
import script from "./PostTippingModal.vue?vue&type=script&lang=ts&"
export * from "./PostTippingModal.vue?vue&type=script&lang=ts&"
import style0 from "./PostTippingModal.vue?vue&type=style&index=0&id=2b5bec82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5bec82",
  null
  
)

export default component.exports